// Write descriptors — the output of every command. Logical paths ("tasks/<id>", "meta/timer",
// "notes/<id>/chunks/body"); the caller turns them into one local batch (= one outbox group = one
// server transaction). Pure data, no store dependency, so the app and the MCP share every command.
export const MAX_GROUP = 200;

export const set = (path, data) => ({ op: 'set', path, data, merge: false });
export const merge = (path, data) => ({ op: 'set', path, data, merge: true });
export const update = (path, data) => ({ op: 'update', path, data });
export const del = (path) => ({ op: 'delete', path });

/** Split a long list of writes into groups of at most MAX_GROUP (each group lands atomically on its own). */
export function chunkWrites(writes, size = MAX_GROUP) {
  const out = [];
  for (let i = 0; i < writes.length; i += size) out.push(writes.slice(i, i + size));
  return out;
}

/** Apply writes to an in-memory map of docs (path → data) — for tests and optimistic previews. */
export function applyWrites(docs, writes) {
  const next = new Map(docs);
  for (const w of writes) {
    if (w.op === 'delete') next.delete(w.path);
    else if (w.op === 'update' || w.merge) next.set(w.path, { ...(next.get(w.path) || {}), ...w.data });
    else next.set(w.path, { ...w.data });
  }
  return next;
}

/** Fold consecutive `update`s to the same path into one (later fields win); other writes keep their order. */
export function mergeUpdates(writes) {
  const out = [];
  const at = new Map();
  for (const w of writes) {
    if (w.op === 'update' && at.has(w.path) && out[at.get(w.path)].op === 'update') { out[at.get(w.path)] = { ...out[at.get(w.path)], data: { ...out[at.get(w.path)].data, ...w.data } }; continue; }
    at.set(w.path, out.length);
    out.push(w);
  }
  return out;
}
